import {fork} from 'redux-saga/effects';
import {combineReducers} from 'redux';

import {sagas as dealAllocate} from './allocate';
import {sagas as dealAnnounce} from './announce';
import {sagas as dealInvite} from './invite';
import {sagas as dealStatus} from './status';
import {sagas as dealLead} from './leadmanage';

import {reducer as allocateR} from './allocate/reducer';
import {reducer as announceR} from './announce/reducer';
import {reducer as inviteR} from './invite/reducer';
import {reducer as statusR} from './status/reducer';

export function* sagas() {
  yield fork(dealAnnounce);
  yield fork(dealInvite);
  yield fork(dealLead);
  yield fork(dealAllocate);
  yield fork(dealStatus);
}

export const reducer = combineReducers({
  allocate: allocateR,
  announce: announceR,
  invite: inviteR,
  status: statusR,
});



// WEBPACK FOOTER //
// ./mobile/shared/flows/deal/index.js